module.exports = __webpack_public_path__ + "img/willow.53357c53.png";